import styled from 'styled-components'
import { useWorld } from '../hooks/use-world'

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: ${({ theme }) => theme.colors('shadow', 0.88)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1020;
  color: ${({ theme }) => theme.colors('danger')};
  font-family: 'Silkscreen', monospace;
`

const Title = styled.div`
  font-size: 3rem;
  font-weight: bold;
  letter-spacing: 0.2em;
  margin-bottom: 1rem;
`

const Score = styled.div`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors('text')};
  margin-bottom: 2rem;
`

const Button = styled.button`
  background: ${({ theme }) => theme.colors('chrome')};
  color: ${({ theme }) => theme.colors('text')};
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.45)};
  padding: 0.75rem 2rem;
  font-family: 'Silkscreen', monospace;
  font-size: 1rem;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.colors('chrome', 0.6)};
  }
`

export const GameOver = ({ onRestart }) => {
  const { score, inventory } = useWorld()

  return (
    <Overlay>
      <Title>GAME OVER</Title>
      <Score>
        <div>Score: {score}</div>
        <div>Items collected: {inventory.length}</div>
      </Score>
      <Button onClick={onRestart}>Play Again</Button>
    </Overlay>
  )
}
